export default class ApplicationNotFound extends Error {
  constructor(message) {
    super(message);
    this.name = "ApplicationNotFound";
  }
}
